import { useIsFetching } from 'react-query';

import type { ITopLoadingBarProps } from './TopLoadingBar';
import { TopLoadingBar } from './TopLoadingBar';

export const TopLoadingBarWithState: React.FC<ITopLoadingBarProps> = (
  props,
) => {
  const currentRequestCount = useIsFetching({
    // Exclude cache refetch queries.
    predicate: (query) => {
      return query.state?.status !== 'success';
    },
  });

  const loading = currentRequestCount > 0;

  return <TopLoadingBar {...props} loading={loading} />;
};
